<template>
  <b-container>
    <div>
      <h1 v-translate>Company Area</h1>
      <hr>
      <div class="row">
        <div class="col-md-3">
          <company-navigation />
        </div>
        <div class="col-md-9 personal-info">
          <h3 v-translate>Invoices</h3>
          <b-table
            show-empty
            :empty-text="$gettext('Filter something to start 😊')"
            :empty-filtered-text="$gettext('There are no results 😞')"
            id="results-table"
            ref="resultsTable"
            stacked="md"
            foot-clone
            :total-rows="totalRows"
            :sort-desc="sortDesc"
            :sort-by="sortBy"
            :per-page="perPage"
            :current-page="currentPage"
            :items="fetchItems"
            :fields="fields"
            :api-url="this.$appConfig.api.baseUrl + 'users/' + this.$store.getters.profile.id + '/invoices'"
            selectedVariant="secondary"
          >
            <template #cell(type_id)="row">
              {{accountingCatalogs.find(x => x.id === row.value).name}}
            </template>
            <template #cell(gross_amount)="row">
              {{row.value | currency($store.getters.profile.company.country_iso_code)}}
            </template>
            <template #cell(generation_date)="row">
              {{moment.utc(row.value).tz($tz).format('L LT')}}
            </template>
            <template #cell(actions)="row">
              <span v-if="row.item.invoice_url">
                <b-button size="sm" variant="primary" :href="row.item.invoice_url" target="_blank" class="p-1 px-2" style="border-radius: 3px;">
                  <font-awesome-icon icon="download" />
                </b-button>
                <b-button @click.prevent="invoice = row.item; fetchTransactions(row.item)" class="p-1 px-2" style="border-radius: 3px;" v-b-modal.modalInvoiceTransactions>
                  <font-awesome-icon :icon="['far', 'eye']" size="1x" />
                </b-button>
              </span>
            </template>
          </b-table>
          <b-pagination v-if="totalRows > perPage" :total-rows="totalRows" :per-page="perPage" v-model="currentPage" class="my-0" />
        </div>
      </div>

      <b-modal size="lg" id="modalInvoiceTransactions" title="Submit your name" hide-footer @hide="invoice = null; transactions = []">
        <div slot="modal-title" v-translate>Invoice Transactions Detail</div>
        <div slot="modal-header-close"><img src="@/assets/img/ic_close.svg" alt="×" /></div>
        <h3 class="row mb-3" v-if="invoice">
          <div class="col-5">
            <small><small class="text-muted" v-translate>ID</small></small><br>
            {{invoice.external_id}}
          </div>
          <div class="col-4 text-right">
            <small><small class="text-muted" v-translate>Generation Date</small></small><br>
            {{moment.utc(invoice.generation_date).tz($tz).format('L LT')}}
          </div>
          <div class="col-3 text-right">
            <small><small class="text-muted" v-translate>Gross Amount</small></small><br>
            <strong>{{invoice.gross_amount | currency($store.getters.profile.company.country_iso_code)}}</strong>
          </div>
          <div class="col-12 mt-5 text-center align-self-center">
            <b-button size="lg" variant="primary" @click.prevent="generateTransactionsReport(invoice.id)">
              <font-awesome-icon icon="download" />
              <translate>Transactions Report</translate>
            </b-button>
          </div>
        </h3>
      </b-modal>
    </div>
  </b-container>
</template>
<script>
import constants from '@/common/constants'
import CompanyNavigation from '@/components/CompanyNavigation'
export default {
  name: 'CompanyInvoicesPage',
  title() {
    return this.$gettext('Integrations')
  },
  components: {
    CompanyNavigation
  },
  data() {
    return {
      invoices: [],
      accountingCatalogs: [],
      totalRows: null,
      sortDesc: true,
      sortBy: 'generation_date',
      perPage: 25,
      currentPage: 1,
      fields: [
        {
          key: 'external_id',
          sortable: false,
          label: this.$gettext('ID')
        },
        {
          key: 'type_id',
          sortable: true,
          label: this.$gettext('Type')
        },
        {
          key: 'gross_amount',
          sortable: false,
          label: this.$gettext('Gross Amount')
        },
        {
          key: 'generation_date',
          sortable: true,
          label: this.$gettext('Generation Date')
        },
        {
          key: 'actions',
          sortable: false,
          label: this.$gettext('Actions')
        }
      ],
      invoice: null,
      transactions: [],
      transactionFields: [
        {
          key: 'shipping_id',
          label: this.$gettext('Shipping ID')
        },
        {
          key: 'addresses',
          label: this.$gettext('Addresses')
        },
        {
          key: 'to_contact',
          label: this.$gettext('Destination Contact')
        },
        {
          key: 'amount_display',
          label: this.$gettext('Amount')
        },
        {
          key: 'imputation_date',
          label: this.$gettext('Date')
        },
        {
          key: 'reason',
          label: this.$gettext('Reason')
        }
      ],
      transactionsCurrentPage: 1,
      transactionsRows: 0,
      transactionsPerPage: 25
    }
  },
  mixins: [constants],
  mounted() {
    this.fetchAccountingStuff()
  },
  methods: {
    fetchItems(ctx) {
      let params = {
        page: ctx.currentPage - 1,
        limit: ctx.perPage,
        sort: [
          {
            key: ctx.sortBy || 'id',
            direction: ctx.sortDesc ? 'desc' : 'asc'
          }
        ]
      }
      return this.$http.get(ctx.apiUrl, { params: params })
        .then(response => {
          this.invoices = response.body.data
          this.totalRows = response.body.pagination.total
          return response.body.data
        })
    },
    refreshTable() {
      setTimeout(() => {
        this.$root.$emit('bv::refresh::table', 'results-table')
      }, 100)
    },
    // TODO: review if the download button only throws many problems or not
    fetchTransactions(invoice) {
      let params = {
        includes: ['shipping'],
        date_from: this.moment(invoice.generation_date).subtract(120, 'day').format('YYYY-MM-DD HH:mm:ss'),
        date_to: this.moment(invoice.generation_date).format('YYYY-MM-DD HH:mm:ss'),
        filter_groups: [
          {
            filters: [
              ['invoice_id', 'eq', invoice.id]
            ]
          }
        ]
      }
      return this.$http.get(this.$appConfig.api.baseUrl + 'companies/' + this.$store.getters.profile.company.id + '/transactions', {params: params})
        .then(response => {
          this.transactions = response.body.data.map(x => {
            x.amount = x.type === 'credit' || parseFloat(x.amount) === 0 ? parseFloat(x.amount) : -(parseFloat(x.amount))
            return {
              shipping_id: x.shipping_id || null,
              reason: x.reason,
              details: x.meta ? (x.meta.reason || (x.meta.meta !== '' ? x.meta.meta : x.meta.details.reason)) : ((x.reason === 'credit_note' || x.reason === 'debit_note') && x.reference ? x.reference : null),
              courier: x.courier ? x.courier.name : '',
              to_contact: x.shipping ? x.shipping.to_contact : '',
              amount: x.amount,
              amount_display: x.type === 'credit' ? x.amount_formatted : '-' + x.amount_formatted,
              imputation_date: x.imputation_date,
              from: x.shipping ? x.shipping.address_from.formatted_address : null,
              to: x.shipping ? x.shipping.address_to.formatted_address : null
            }
          })
          return this.transactions
        })
    },
    fetchAccountingStuff() {
      let params = {
        sort: [{
          key: 'name',
          direction: 'asc'
        }],
        filter_groups: [
          {
            filters: [
              ['country_iso_code', 'eq', this.$store.getters.profile.company.country_iso_code],
              ['catalog', 'eq', 'transaction_types']
            ]
          }
        ]
      }
      return this.$http.get(this.$appConfig.api.baseUrl + 'accounting-catalogs', {params: params})
        .then(response => {
          this.accountingCatalogs = response.body.data
        })
    },
    generateTransactionsReport(invoiceId) {
      let params = {
        format: 'upload'
      }
      this.$http.get(this.$appConfig.api.baseUrl + 'companies/' + this.$store.getters.profile.company.id + '/invoices/' + invoiceId + '/transactions', {params: params})
        .then(response => {
          let obj = {
            title: this.$gettext('JOB DISPATCHED'),
            message: this.$gettext('The Transactions Report is being generated, you will receive an email with a link to download it as soon as it\'s done'),
            type: 'success'
          }
          this.$root.$children[0].$refs.simplert.openSimplert(obj)
        })
    }
  }
}

</script>
